
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.59 1.25a2.4 2.4 0 00-2.388 2.387v4.77a2.4 2.4 0 002.387 2.387h4.774a2.397 2.397 0 002.384-2.387v-4.77a2.397 2.397 0 00-2.384-2.387H11.59zm0 1.59h4.773c.455 0 .796.343.796.797v4.77a.777.777 0 01-.796.796H11.59a.777.777 0 01-.795-.796v-4.77c0-.455.34-.796.795-.796zM3.635 4.433A2.4 2.4 0 001.25 6.82v1.588a2.4 2.4 0 002.386 2.387h1.592a2.397 2.397 0 002.384-2.387V6.819a2.397 2.397 0 00-2.384-2.387H3.636zm0 1.591h1.592c.454 0 .792.342.792.796v1.588a.775.775 0 01-.792.796H3.636a.777.777 0 01-.795-.796V6.82c0-.454.34-.796.795-.796zm0 6.362a2.399 2.399 0 00-2.386 2.386v1.592a2.4 2.4 0 002.386 2.387h1.592a2.397 2.397 0 002.384-2.387v-1.591a2.397 2.397 0 00-2.384-2.387H3.636zm7.953 0a2.4 2.4 0 00-2.387 2.386v1.592a2.4 2.4 0 002.387 2.387h1.592a2.4 2.4 0 002.386-2.387v-1.591a2.399 2.399 0 00-2.386-2.387h-1.592zm-7.953 1.591h1.592c.454 0 .792.341.792.795v1.592a.774.774 0 01-.792.795H3.636a.777.777 0 01-.795-.795v-1.591c0-.455.34-.796.795-.796zm7.953 0h1.592c.454 0 .795.341.795.795v1.592a.777.777 0 01-.795.795h-1.592a.777.777 0 01-.795-.795v-1.591c0-.455.34-.796.795-.796z"}})])
          )
        }
      }
    